


import logoImg from '../assets/images/logo.png';
import defaultProfileImg from '../assets/images/default-user.png';

const optionsEndPoint = {
  version: 'v1',
  port: 80,
}

// Vite exposes env variables via import.meta.env
// Variables must be prefixed with VITE_ in .env file to be accessible in frontend
const name = import.meta.env.VITE_APP_TITLE;

const serverEndPoint = import.meta.env.VITE_END_POINT;
const urlPro = import.meta.env.VITE_APP_URL;
const isProduction = import.meta.env.MODE === "production"
const endpoint = isProduction ? `${serverEndPoint}/wp-json/wp/${optionsEndPoint.version}` : `${import.meta.env.VITE_LOCAL_END_POINT}/wp-json/wp/${optionsEndPoint.version}`;
const urlHome = isProduction ? `${serverEndPoint}` : `${import.meta.env.VITE_LOCAL_END_POINT}`;
const server_socket = isProduction ? `${urlPro}` : `${import.meta.env.VITE_LOCAL_SERVER_SOCKET}`;
const platform = "webapp";
const wpJson = `${urlHome}/wp-json`
const nameApp = import.meta.env.VITE_APP_NAME ? import.meta.env.VITE_APP_NAME : ""
const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ? import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY : ""

const testEmail = !isProduction && import.meta.env.VITE_email ? import.meta.env.VITE_email : ""
const testPassword = !isProduction && import.meta.env.VITE_password ? import.meta.env.VITE_password : ""

export default {
  endpoint,
  urlHome,
  wpJson,
  server_socket,
  testEmail,
  testPassword,
  logo: logoImg,
  defaultProfile: defaultProfileImg,
  imageAnonymous: defaultProfileImg,
  name: "MoveSheet",
  name2: "MoveSheet",
  nameApp,
  suffixEmail: "movesheet.com",
  platform,
  isProduction,
  phone: ' (303) 536-5126',
  address: " Denver, CO ",
  socialMedia: {
    Facebook: `https://www.facebook.com/${nameApp}/`,
    twitter: `https://twitter.com/${nameApp}`,
    googlePluse: `https://plus.google.com/${nameApp}`,
    yelp: `http://yelp.com/biz/${nameApp}`,
    instagram: `http://instagram.com/${nameApp}/`
  },

  keyMap: 'AIzaSyBsXGwUylrKQtCeqoOJinUqBBueLs5cwME',
  keyMapBox: "pk.eyJ1IjoiYXRsYXNsYWJvciIsImEiOiJjanY1em15YjUwNGR6NDlwb2UwNTV0YXlnIn0.XhlWArIBRK9j8BnhtdREYQ",
  keyAPI: "AIzaSyBsXGwUylrKQtCeqoOJinU",
  stripePublishableKey: stripePublishableKey,
  coords: {
    lat: 37.78825,
    long: -122.4324,
    latitudeDelta: 0.0922,
    longitudeDelta: 0.0421 * 50,
  },
  region: {
    latitude: 37.78825,
    longitude: -122.4324,
    latitudeDelta: 0.1,
    longitudeDelta: 0.1
  },
  coordinate: {
    lat: 37.78825,
    lng: -122.4324,
  },
  DEFAULT_PADDING: { top: 40, right: 40, bottom: 40, left: 40 },

  description: "MoveSheet",
  color: {
    Primarycolor: '#f8f9fa',
    SecondaryColor: '#4B3C67',

    backgroundScreen: '#FFF',
    colorRad: "#cc0000",
    colorGreen: "#198c19",
    colorBlue: "#1919ff",
    colorYellow: "#ffff19",
  },
  fontFamily: "Arial",
  amountAddJob: 15,

  placeholderTextColor: "rgba(0, 0, 0, 0.42);",
  allowedMimeTypes: ["application/pdf", "image/png", "image/jpg", "image/jpeg"],
  url: {
    home: `${urlHome}`,
    wpJson: `${wpJson}`,
    login: `${endpoint}/login`,
    token: `${wpJson}/wp/v2/token`,
    job: `${endpoint}/job`,
    jobs: `${wpJson}/wp/v2/jobs`,
    city: `${endpoint}/city`,
    account: `${endpoint}/account`,
    twilio: `${wpJson}/wp/v2/twilio`,
    info: `${endpoint}/info`,
    documents: `${wpJson}/wp/v2/documents`,
    documents_categories: `${wpJson}/wp/v2/documents_categories`,
    documentsJobs: `${wpJson}/wp/v2/documents-jobs`,
    settings: `${wpJson}/wp/v2/account-settings`,
    clients: `${wpJson}/wp/v2/clients`,
    companies: `${wpJson}/wp/v2/companies`,
    workers: `${wpJson}/wp/v2/workers`,
    payments: `${wpJson}/wp/v2/payments`,
    manuals: `${wpJson}/wp/v2/manuals`,
    users: `${wpJson}/wp/v3/users`,
    transactions: `${wpJson}/wp/v2/transactions`,
    cards: `${wpJson}/wp/v2/payments/cards`,
    emailAvailable: `${wpJson}/wp/v2/movesheet/email-available`,
    me: `${wpJson}/wp/v2/users/me`,
    financials: `${wpJson}/wp/v2/financials`,
    financialsYears: `${wpJson}/wp/v2/financials/years`,
    financialsOverview: `${wpJson}/wp/v2/financials/overview`,
    documentsset: `${wpJson}/wp/v2/documentsset`,
    disputes: `${wpJson}/wp/v2/disputes`,
    documentByCompanyJobAndTemplate: `${wpJson}/wp/v2/documents/job`
  },
  dateFormat: {
    date: 'MM/dd/yyyy',
    dateTime: 'MMM DD, YYYY - h:mm A',
    time12Hours:"h:mm A"
  },
  optionsRecurringType: ["Every Week", "Every Other Week", "Every Month"],
  initCities: "hou",



  jobRate: {
    20: false,
    40: false,
    60: false,
    80: false,
    100: false
  },
  defaultServiceFee: 50,
  defaultBookingFee: 50,
  dateSwitched: "4/10/2022",
};
